import { cn } from "@tellescope/ui";

export const CLASSIFICATION_CLASS_NAMES: Record<string, string> = {
  Target: cn("bg-green-100 text-green-700 border-green-400"),
  High: cn("bg-yellow-100 text-yellow-700 border-yellow-400"),
  Low: cn("bg-yellow-100 text-yellow-700 border-yellow-400"),
  "Very High": cn("bg-red-100 text-red-700 border-red-400"),
  "Very Low": cn("bg-red-100 text-red-700 border-red-400"),
  "Critical High": cn("bg-fuchsia-100 text-fuchsia-700 border-fuchsia-400"),
  "Critical Low": cn("bg-fuchsia-100 text-fuchsia-700 border-fuchsia-400"),
};
